import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=2847d39b&scoped=true"
import script from "./roleManagement.vue?vue&type=script&lang=js"
export * from "./roleManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=2847d39b&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=2847d39b&prod&lang=scss&scoped=true&external"
import style2 from "./roleManagement.vue?vue&type=style&index=2&id=2847d39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847d39b",
  null
  
)

export default component.exports